module.exports = __webpack_public_path__ + "img/le-vesuvio.6ce25f94.jpg";